import * as React from "react";
import { PracticeDetails } from "./practice-management/Practice";
import HeaderBar from "./commons/components/HeaderBar";
import FeaturesSelector, { FeaturesSelectorProps } from "./practice-management/FeaturesSelector";
import PracticeDetailsView from "./practice-management/PracticeDetailsView";
import UserCardMedium from "./commons/components/user/UserCardMedium";
import UserInfo from "./commons/model/UserInfo";
import ImpersonateAction from "./commons/model/ImpersonateAction";
import Country from "./commons/model/address/Country";
import { createRoot } from "react-dom/client";

interface UserProfileProps {
  user: UserInfo;
  editPracticeUrl: string;
  isAdmin: boolean;
  practiceDetailsProps?: PracticeDetailsProps;
  featureView?: FeaturesSelectorProps;
  impersonateAction: ImpersonateAction;
  hasDso: boolean;
}

interface PracticeDetailsProps {
  practiceDetails: PracticeDetails;
  countries: Country[];
}

export default class UserProfile extends React.Component<UserProfileProps> {
  render(): React.ReactNode {
    const user = this.props.user;
    return (
      <>
        <HeaderBar title={user.name} />
        <div className="container">
          <div className="grid-container">
            <div className="profile">
              <div className="panel with-shadow">
                <div className="panel-title">{i18n["Page.UserManagement.Profile"]}</div>
                <UserCardMedium user={user} impersonateAction={this.props.impersonateAction} />
              </div>
            </div>
            <div className="practice-details">
              {this.props.practiceDetailsProps && (
                <PracticeDetailsView
                  practiceDetails={this.props.practiceDetailsProps.practiceDetails}
                  editPracticeUrl={this.props.editPracticeUrl}
                  isAdmin={this.props.isAdmin}
                />
              )}
            </div>
            <div className="features">
              {this.props.featureView && (
                <FeaturesSelector
                  {...this.props.featureView}
                  hasActiveSubscription={user.hasActiveSubscription}
                  hasDso={this.props.hasDso}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  static loadComponent(elementId: string, props: UserProfileProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<UserProfile {...props} />);
  }
}
